<template>
  <el-tooltip placement="top" :show-after="150" :popper-class="style.tooltip">
    <slot />
    
    <template v-if="slots.content" #content>
      <div :class="[style.content,'break-word']" :style="{width: `${width}px`}">
        <slot name="content" />
      </div>
    </template>
  </el-tooltip>
</template>

<script setup lang="ts">
const slots = useSlots();

defineProps({
  width: {
    type: [String, Number],
    default: 200
  }
});

</script>

<style lang="scss" module="style">
.tooltip {
  &:global(.is-dark) {
    color: var(--text-text0);
    border: 1px solid var(--toast-toast1);
    background: 1px solid var(--toast-toast1\2);
  }
}
.content{
  overflow: hidden;
}

</style>
